import { Skeleton } from "@/components/ui/skeleton";

/**
 * Loading placeholders for the DiscoveryRail's compact rows. Sized to the real
 * rows (48px thumb + two text lines + a trailing pill / avatar) so the rail keeps
 * its shape during the initial fetch instead of collapsing to nothing.
 */
export function RailRowSkeleton() {
  return (
    <div className="flex items-center gap-3 rounded-2xl p-2.5">
      <Skeleton className="size-12 shrink-0 rounded-lg" />
      <div className="min-w-0 flex-1 space-y-2">
        <Skeleton className="h-3 w-[80%] rounded" />
        <Skeleton className="h-3 w-[45%] rounded" />
      </div>
      <Skeleton className="h-7 w-16 shrink-0 rounded-full" />
    </div>
  );
}

export function RailSectionSkeleton({ count = 4 }: { count?: number }) {
  return (
    <div className="flex flex-col gap-1.5">
      {Array.from({ length: count }).map((_, i) => (
        <RailRowSkeleton key={i} />
      ))}
    </div>
  );
}

export function RailSellerRowSkeleton() {
  return (
    <div className="flex items-center gap-3">
      <Skeleton className="size-10 shrink-0 rounded-full" />
      <div className="min-w-0 flex-1 space-y-2">
        <Skeleton className="h-3.5 w-[55%] rounded" />
        <Skeleton className="h-3 w-[35%] rounded" />
      </div>
      <Skeleton className="h-8 w-20 shrink-0 rounded-full" />
    </div>
  );
}
